import * as z from "zod/v4";

export const updateOmsApparelMagicIntegration = {
  name: "updateOmsApparelMagicIntegration" as const,
  input: z.object({ usePickTicketNumberAsOrderName: z.boolean().optional() }),
  output: z.object({ success: z.boolean() }),
};
